import { Box, Skeleton, SxProps } from '@mui/material';

interface SkeletonLoaderProps {
  height?: number;
  sx?: SxProps;
}

export default function SkeletonLoader({ height, sx }: SkeletonLoaderProps) {
  return (
    <Box sx={{ display: 'flex', m: 0, '& .MuiSkeleton-root': { borderRadius: 0 }, ...sx }}>
      <Skeleton
        variant="rectangular"
        width="100%"
        sx={{ height: height || 300, borderRadius: 2 }}
      />
    </Box>
  );
}